<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import MainLayout from '../layouts/MainLayout'; // Your current layout
import AuthLayout from '../layouts/AuthLayout.vue'; // Create a new blank layout
import DefaultLayout from '../layouts/DefaultLayout.vue'; // Create a new blank layout

export default {
  name: "Layout",
  components: {
    MainLayout,
    AuthLayout,
    DefaultLayout
  },
  computed: {
    layout() {
      const routeLayout = this.$route.meta.layout || 'def';
      return routeLayout === 'auth' ? AuthLayout : routeLayout === 'main' ? MainLayout : DefaultLayout;
    }
  },
};
</script>